// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"So-z","badgeLink":"To-z","category":"Uo-z"};